export default {
  fontFamily: 'Arial',

  // Линия сверху
  'chart-row-progress-bar-solid': {
      fill: '#0EAC51',
      height: '20%'
  },
  // Паттерн
  'chart-row-progress-bar-pattern': {
    fill: 'url(#diagonalHatch)',
    transform: 'translateY(0.1) scaleY(0.8)'
  },
  // Линия завершенности
  'chart-row-progress-bar-outline': {
    stroke: '#E74C3C',
    'stroke-width': 1
  },

  'chart-day-hilghlight-rect': {
    fill: '#fafafa',
    stroke: '#f0f0f0',
    'stroke-width': 1
  }
}